export const RESUME_URL =
  "https://drive.google.com/file/d/1gwMvsTkUPxTac86Zf0jYZvQ9D2W_cVcE/view?usp=sharing";

export const SOCIALS = {
  github: "https://github.com/harshit1142",
  linkedin: "https://www.linkedin.com/in/harshit-pandey-312b78245/",
  leetcode: "https://leetcode.com/u/HARSHIT98765/",
  codechef: "https://www.codechef.com/users/harshit98765",
  codolio: "https://codolio.com/profile/harshit.in",
  email: "harshitpandey4024@gmail.com",
  phone: "+91 8303733576",
};

export const ACHIEVEMENTS = [
  {
    text: "Secured 1st place in Webcode, a web development competition, Avishkar 2024 at MNNIT Allahabad.",
    label: "Certificate",
    href: "https://drive.google.com/file/d/1G2qamSeU4BBLK9-N2_JktFQnfuXcJIxm/view",
  },
  {
    text: "Secured a rank of 3532 in Meta HackerCup 2023 out of 20,000 participants.",
    label: "Certificate",
    href: "https://www.facebook.com/codingcompetitions/hacker-cup/2023/certificate/1032918467839188",
  },
  {
    text: "Open-Source Contributor and Project Maintainer at Hacktoberfest 2023 & 2024.",
    label: "Certificate",
    href: "https://www.holopin.io/hacktoberfest2023/hall/@harshit1142",
  },
  {
    text: "Awarded Winner of 'Palladin' (Mock Placement event in Software Domain) in Avishkar 2024.",
    label: "Certificate",
    href: "https://drive.google.com/file/d/1R7cT51-TIDiaPqqrsKR1aDmVqGXhvCfd/view",
  },
  {
    text: "2nd Runner-up in Innodev, a web development competition, Avishkar 2024 at MNNIT Allahabad.",
    label: "Certificate",
    href: "https://drive.google.com/file/d/1kfkVF7-QNUArJVxV1ZLLMj8dxsKjGbCf/view",
  },
  {
    text: "Knight at LeetCode with a contest rating of 1850+.",
    label: "Profile",
    href: SOCIALS.leetcode,
  },
  {
    text: "3-Star rating with a rating of 1650+ on CodeChef.",
    label: "Profile",
    href: SOCIALS.codechef,
  },
];

export const EXPERIENCE = [
  {
    company: "Clink AI Technologies Pvt. Ltd.",
    role: "Software Development Intern",
    place: "Bangalore, India",
    period: "Feb 2026 — Present",
    current: true,
    points: [
      "Built production screens for a React Native (Expo) app from Figma specs, using Reanimated worklets for gesture-driven bottom sheets and 60fps UI-thread transitions.",
      "Cut wasted re-renders on list-heavy screens via React.memo, useMemo/useCallback, and virtualized lists, improving scroll performance and time-to-interactive.",
      "Shipped an interactive discovery map with MapLibre GL — custom style spec, sprite-based category markers, clustering, and imperative camera control via refs.",
      "Owned the mobile release pipeline with EAS Build/Submit for App Store and Play Store deployment, shipping instant fixes over-the-air via EAS Update.",
      "Implemented type-safe navigation and deep linking with Expo Router and expo-notifications, mapping push payloads to nested routes with cold-start handling.",
      "Engineered an internal Sales Analytics Dashboard in Next.js (App Router) with React Server Components and SSR, shrinking the client bundle and improving load times.",
    ],
    tags: ["React Native", "Expo", "Reanimated", "MapLibre GL", "Next.js", "EAS"],
  },
  {
    company: "Training & Placement Representative",
    role: "MNNIT, Allahabad",
    place: "Allahabad, India",
    period: "Jan 2025 — Present",
    current: true,
    points: [
      "Acted as a key liaison between the placement cell and students, ensuring timely communication of internship and job opportunities.",
      "Organized training sessions, mock interviews, and resume-building workshops to enhance placement preparedness among peers.",
      "Collected and analyzed student data to assist recruiters in shortlisting eligible candidates effectively.",
      "Collaborated with company HRs and placement coordinators to facilitate smooth conduction of recruitment drives on campus.",
    ],
    tags: ["Leadership", "Coordination"],
  },
  {
    company: "Hacktoberfest",
    role: "Project Maintainer",
    place: "Remote",
    period: "Oct 2023 & Oct 2024",
    points: [
      "Reviewed, merged, and gave feedback on pull requests from contributors around the globe, keeping code quality, structure, and functionality consistent.",
      "Identified and raised issues with clear descriptions, expectations, and technical guidance for contributors to work on.",
      "Helped developers navigate the codebases, mentoring on best practices in coding, debugging, and open-source collaboration.",
    ],
    tags: ["Open Source", "Code Review", "Git"],
  },
  {
    company: "DigiBask",
    role: "Front-End Developer",
    place: "Remote",
    period: "Apr 2024",
    points: [
      "Developed and launched the 'Student-Assistant-Client' platform, designed specifically for students of HBTU Kanpur.",
      "Facilitated the buying and selling of products such as notes, books, and other college-related items.",
    ],
    tags: ["React.js", "Front-End"],
    link: {
      href: "https://drive.google.com/file/d/1qHu0YEUcBLOJ5gsCa_0rm2mzD3ZPcJ0T/view?usp=sharing",
      label: "Letter of Recommendation",
    },
  },
  {
    company: "Student Mentorship Program",
    role: "Mentor",
    place: "MNNIT, Allahabad",
    period: "Sep 2023 — Present",
    current: true,
    points: [
      "Provided tailored guidance to juniors on academic challenges, career planning, and skill development.",
      "Encouraged participation in hackathons, coding contests, and open-source projects, sharing strategies for success.",
      "Monitored mentees' progress regularly and provided actionable feedback to help them achieve their goals.",
    ],
    tags: ["Mentorship"],
  },
];

export const EDUCATION = [
  {
    school: "Motilal Nehru National Institute of Technology, Allahabad",
    degree: "B.Tech in Biotechnology",
    period: "2022 — 2026",
    score: "7.6 CPI",
    place: "Allahabad, Uttar Pradesh",
  },
  {
    school: "St. Basil's School, Basti",
    degree: "12th — Indian School Certificate (ISC)",
    period: "2020 — 2021",
    score: "94.25%",
  },
  {
    school: "St. Basil's School, Basti",
    degree: "10th — Indian Certificate of Secondary Education (ICSE)",
    period: "2018 — 2019",
    score: "90.79%",
  },
];
